import { ToastContainer } from 'react-toastify'
import { SearchIcon } from '../../assets/icons/search'
import { colors } from '../../theme'
import {
  Container,
  SpanIcon,
  FilterStatus,
  SpanFilter,
  Ul,
  Td,
} from '../../layouts/LayoutTable/LayoutTable'
import { FilterIcon } from '../../assets/icons/filter'
import { ItemFilter } from '../../components/ItemFilter/ItemFilter'
import { GenericTable } from '../../components/GenericTable/GenericTable'

import { Button } from '../../components/SideBar/Menu.style'
import { DivTitle } from '../../components/TitlePage/TitlePage'
import { Pagination } from '../../components/Pagination/Pagination'
import { Loading } from '../../components/Loading/Loading'
import { useCompanies } from './useCompanies'
import { DivInput, InputStyle, Span } from '../Users/Users.style'

export function Companies() {
  const {
    searchValue,
    setSearchValue,
    isShowFilter,
    currentPage,
    setCurrentPage,
    companies,
    fetchCompanies,
    isLoading,
    handleKeyDown,
    showFilter,
    goToPageCompaniesDetails,
    statusChecked,
    statusCheckedTodos,
    setStatusCheckedFiltro,
    handleCheckboxChange,
  } = useCompanies()

  return (
    <div>
      <ToastContainer theme="dark" />
      <DivTitle color="black" size={22}>
        Empresas
      </DivTitle>
      <Container>
        <DivInput>
          <InputStyle
            value={searchValue}
            onChange={event => setSearchValue(event.target.value)}
            onKeyDown={handleKeyDown}
            border={colors.grey300}
            placeholder="Pesquise uma palavra-chave"
            sizeX="264px"
            sizeY="42px"
          />
          <Span onClick={fetchCompanies}>
            <SearchIcon />
          </Span>
          <SpanIcon onClick={showFilter}>
            <FilterIcon />
          </SpanIcon>
          <div>
            {isLoading ? (
              <Loading contrast={false} />
            ) : (
              <>
                <GenericTable
                  size="270px"
                  headers={['Empresa', 'Status']}
                  spacing="60px"
                  font="16px"
                >
                  {companies.content &&
                    companies.content.map(empresa => (
                      <tr
                        className="itemTable"
                        key={empresa.id}
                        onClick={() => goToPageCompaniesDetails(empresa.id)}
                      >
                        <td className="col2">{empresa.nome}</td>
                        <td className="col2">
                          <Td classification={empresa.classificacao}>
                            {empresa.classificacao
                              .replace('_', ' ')
                              .toLowerCase()}
                          </Td>
                        </td>
                      </tr>
                    ))}
                </GenericTable>
                <Pagination
                  pageNumber={currentPage}
                  pageSize={companies.totalElements}
                  offSet={companies.size}
                  onClick={page => setCurrentPage(page)}
                />
              </>
            )}
          </div>
        </DivInput>

        {isShowFilter && (
          <FilterStatus>
            <SpanFilter>Filtrar por: </SpanFilter>

            <div>
              <Ul>
                <ItemFilter
                  top="2px"
                  checked={!statusCheckedTodos.includes('TODOS')}
                  onChange={() => {
                    handleCheckboxChange('TODOS')
                  }}
                  text="Todos"
                  id="all"
                />
                <ItemFilter
                  top="2px"
                  checked={statusChecked.includes('EM_ALTA')}
                  onChange={() => {
                    handleCheckboxChange('EM_ALTA')
                  }}
                  text="Em alta"
                  id="onHigh"
                />
                <ItemFilter
                  top="2px"
                  checked={statusChecked.includes('EM_BAIXA')}
                  onChange={() => {
                    handleCheckboxChange('EM_BAIXA')
                  }}
                  text="Em baixa"
                  id="low"
                />
                <ItemFilter
                  top="2px"
                  checked={statusChecked.includes('NEUTRO')}
                  onChange={() => {
                    handleCheckboxChange('NEUTRO')
                  }}
                  text="Neutro"
                  id="neutro"
                />
              </Ul>
            </div>
            <Button
              buttonType="SMALL"
              type="button"
              onClick={() => {
                setStatusCheckedFiltro(statusChecked)
                showFilter()
              }}
            >
              Aplicar
            </Button>
          </FilterStatus>
        )}
      </Container>
    </div>
  )
}
